import React from 'react';
import { WalletCreditItemType } from 'types/WalletCredit';
import { IndividualTicketType } from 'utils/tickets';
import AddonsList from '../AddonsList';

import { DateTime } from 'luxon';
import { dateFormatForCalendar } from 'utils/calendar';

interface TopUpWalletProps {
  tickets: IndividualTicketType[];
  wallet: WalletCreditItemType | undefined;
}

const TopUpWallet: React.FC<TopUpWalletProps> = ({ tickets, wallet }) => {
  // --- legacy code for top up wallet ---
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const cartTopUps = useSelector(selectTopUpsFromCart);

  // selected amounts
  // const getInitialSelectedAmounts = () => {
  //   const result = Array.from({ length: tickets.length }, () => '');

  //   for (let i = 0; i < cartTopUps.length; i++) {
  //     if (cartTopUps[i].ticketIndex !== undefined) {
  //       result[`${cartTopUps[i].ticketIndex}`] = cartTopUps[i].price.toString();
  //     }
  //   }
  //   return result;
  // };
  // const [selectedAmounts, setSelectedAmounts] = useState<string[]>(
  //   getInitialSelectedAmounts(),
  // );
  // const { preset_amounts, currency, min_amount, max_amount } = wallet || {};
  // const displayedPresetAmounts =
  //   preset_amounts && preset_amounts.length > 0
  //     ? ['0', ...preset_amounts.filter(el => parseInt(el))]
  //     : [];
  // const minAmount = min_amount || 10;
  // const maxAmount = max_amount || Number.MAX_VALUE;
  // const topUpIsNotCostume = !min_amount && !max_amount;

  // const {
  //   clearErrors,
  //   setValue,
  //   formState: { errors },
  // } = useFormContext();

  // useEffect(() => {
  //   if (cartTopUps.length > 0) {
  //     for (let i = 0; i < cartTopUps.length; i++) {
  //       setValue(
  //         cartTopUps[i].ticketId +
  //           '-' +
  //           cartTopUps[i].ticketIndex +
  //           '-' +
  //           cartTopUps[i].idOrderItem,
  //         cartTopUps[i].price,
  //       );
  //     }
  //   }
  // }, [cartTopUps]);

  // const handleChange = (e, index, id, date) => {
  //   const value = e.target.value;
  //   const newAmounts = [...selectedAmounts];
  //   newAmounts[index] = value;
  //   setSelectedAmounts(newAmounts);

  //   // handle store
  //   dispatch(
  //     addTopUpsToSelectedItems({
  //       ticketId: id,
  //       ticketIndex: index,
  //       price: parseInt(value),
  //       // we need idOrderItem in the BE for identifying for which ticket the top up is
  //       idOrderItem:
  //         tickets.find(ticket => ticket.ticketId === id)?.idOrderItem || '',
  //       ticketDate: date,
  //     }),
  //   );
  // };

  // const handleSelectAmount = (amount, inputName, index, date) => {
  //   const newAmounts = [...selectedAmounts];
  //   newAmounts[index] = parseInt(amount) > 0 ? amount : '';

  //   setSelectedAmounts(newAmounts);
  //   setValue(inputName, amount);
  //   clearErrors(inputName);

  //   // handle store
  //   const ticketId = inputName.split('-')[0];
  //   const ticketIndex = inputName.split('-')[1];
  //   dispatch(
  //     addTopUpsToSelectedItems({
  //       ticketId,
  //       ticketIndex: parseInt(ticketIndex),
  //       price: parseInt(amount),
  //       idOrderItem:
  //         tickets.find(ticket => ticket.ticketId === ticketId)?.idOrderItem ||
  //         '',
  //       ticketDate: date,
  //     }),
  //   );
  // };

  return (
    <>
      {tickets.map(
        ({ ticketId, name, idOrderItem, date, bundleId }, ticketIndex) => (
          <div key={`${ticketId}-${ticketIndex}-${idOrderItem}`}>
            <div className="flex items-center gap-3 mb-2">
              <p className="p1-medium text-neutral-600">#{ticketIndex + 1}</p>
              <p className="p1-medium">
                {name}
                {date ? (
                  <span className="p4-regular text-neutral-800 ml-1">
                    (
                    {DateTime.fromFormat(date, dateFormatForCalendar).toFormat(
                      'cccc, LLLL d',
                    )}
                    )
                  </span>
                ) : null}
              </p>
            </div>
            <AddonsList
              ticketId={ticketId}
              ticketIndex={ticketIndex}
              ticketDate={date}
              bundleId={bundleId}
            />
            {ticketIndex < tickets.length - 1 ? <hr className="my-4" /> : null}
            {/* {wallet ? (
              <div className="bg-neutral-10 py-[12px] px-[12px] my-[12px]">
                <h3 className="font-medium mb-[12px]">
                  {t('ticketSale.topUp')}
                </h3>
                <div className="relative [&>input]:pl-[30px] px-[8px]">
                  <p className="p1-medium remove-input-arrows absolute left-[20px] top-[7px]">
                    {getSymbolFromCurrency(currency as string)}
                  </p>
                  <Controller
                    name={`${ticketId}-${ticketIndex}-${idOrderItem}`}
                    rules={{
                      validate: {
                        numberIsValid: async value => {
                          if (
                            value === undefined ||
                            value === '' ||
                            value === '0'
                          )
                            return true;
                          const valueIsValid = await numberInIntervalSchema(
                            minAmount,
                            maxAmount,
                          ).isValid(parseInt(value));
                          if (!valueIsValid) {
                            return 'error';
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <input
                        readOnly={topUpIsNotCostume}
                        className="standard-input w-[117px]"
                        type="number"
                        value={selectedAmounts[ticketIndex]}
                        onChange={e => {
                          handleChange(e, ticketIndex, ticketId, date);
                          field.onChange(e);
                        }}
                      />
                    )}
                  />
                  {errors[`${ticketId}-${ticketIndex}-${idOrderItem}`]
                    ?.message && (
                    <p className="standard-input-error mt-[4px]">
                      {max_amount
                        ? t('inputErrors.numberInInterval', {
                            min: minAmount,
                            max: max_amount,
                          })
                        : t('inputErrors.numberGreaterThan', {
                            min: minAmount,
                          })}
                    </p>
                  )}

                  {displayedPresetAmounts.length > 0 ? (
                    <div className="flex flex-wrap mt-[8px] gap-[8px]">
                      {displayedPresetAmounts.map((amount, index) => (
                        <p
                          key={`${amount}-${index}`}
                          onClick={() =>
                            handleSelectAmount(
                              amount,
                              `${ticketId}-${ticketIndex}-${idOrderItem}`,
                              ticketIndex,
                              date,
                            )
                          }
                          className="p2-semibold rounded-[5px] py-[10px] text-center w-[115px] bg-blue-20 text-blue-1000"
                        >
                          {parseInt(amount) > 0 ? `+${amount}` : amount}
                        </p>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null} */}
          </div>
        ),
      )}
    </>
  );
};

export default TopUpWallet;
